export enum AppButtonTypeEnum {
    TEXT_ONLY_BUTTON,
    ICON_ONLY_BUTTON,
    ICON_WITH_TEXT_BUTTON
}
